import { render, staticRenderFns } from "./FeedSettings.vue?vue&type=template&id=90a442c6&scoped=true"
import script from "./FeedSettings.vue?vue&type=script&lang=js"
export * from "./FeedSettings.vue?vue&type=script&lang=js"
import style0 from "./FeedSettings.vue?vue&type=style&index=0&id=90a442c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a442c6",
  null
  
)

export default component.exports